<template>
  <div class="batch-wrapper">
    <div class="batch-title">- {{ year }}年高考录取可查询批次 -</div>
    <div class="batch-table">
      <div class="table-header">
        <div>省份</div>
        <div>批次</div>
        <div>结束时间</div>
      </div>
      <div v-for="(row, index) in batchList" :key="index" class="table-row">
        <div>{{ row.province }}</div>
        <div>{{ row.batchName }}</div>
        <div>{{ row.endTime }}</div>
      </div>
    </div>
  </div>
</template>     

<script>
export default {
  name: "BatchWrapper",
  props: {
    batchList: Array,
  },
  data() {
    return {
      year: null,
    };
  },
  created() {
    this.year = new Date().getFullYear();
  },
};
</script>

<style lang="scss" scoped>
.batch-wrapper {
  background: #f6f6f6;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 48px 0;
  .batch-title {
    color: #535353;
    font-size: 22px;
  }

  .batch-table {
    margin-top: 40px;
    width: 800px;
    max-width: 100%;
    border-radius: 8px;
    overflow: hidden;
    background: #ffffff;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    opacity: 1;
    .table-header {
      height: 48px;
      line-height: 48px;
      background: #69000e;
      font-size: 18px;
      color: #fff;
    }
    .table-row {
      min-height: 64px;
      // line-height: 64px;
      background: #fff;
      font-size: 18px;
      color: #535353;
      &:nth-child(2n + 1) {
        background: #f9f6f6;
      }
    }
    .table-header,
    .table-row {
      display: flex;
      & > div {
        flex: 1;
        display: flex;
        justify-content: center;
        text-align: center;
        align-items: center;
      }
    }
  }
}

@media only screen and (max-width: 600px) {
  .batch-wrapper {
    padding: 30px 0;
    .batch-title {
      color: #535353;
      font-size: 15px;
    }
    .batch-view-finish {
      font-size: 15px;
      margin-top: 8px;
      margin-bottom: 16px;
    }
    .batch-table {
      width: 90%;
      margin-top: 20px;
      .table-header {
        height: 35px;
        font-size: 16px;
      }
      .table-row {
        min-height: 46px;
        font-size: 14px;
      }
    }
  }
}
</style>

